import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const HeroContainer = styled.div`
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  margin-bottom: 20px;
  width: 100%;
`;
